import { render, staticRenderFns } from "./CfdisRelatedReplacement.vue?vue&type=template&id=51d753fb&"
import script from "./CfdisRelatedReplacement.vue?vue&type=script&lang=js&"
export * from "./CfdisRelatedReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d753fb')) {
      api.createRecord('51d753fb', component.options)
    } else {
      api.reload('51d753fb', component.options)
    }
    module.hot.accept("./CfdisRelatedReplacement.vue?vue&type=template&id=51d753fb&", function () {
      api.rerender('51d753fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/CFDI/CfdisRelatedReplacement.vue"
export default component.exports